import React, { Component, useState } from 'react';
import { array, arrayOf, bool, func, number, string } from 'prop-types';
import ProgressBar from '../ProgressBar/ProgressBar';
import StepNavigation from '../ProgressBar/StepNavigation';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import classNames from 'classnames';
import {
  TRANSITION_REQUEST_PAYMENT_AFTER_ENQUIRY,
  txIsAccepted,
  txIsCanceled,
  txIsDeclined,
  txIsEnquired,
  txIsPaymentExpired,
  txIsPaymentPending,
  // txIsRequested,
  txHasBeenDelivered,
  txIsBookingPending,
  txIsConfirmed,
  txIsInFirstReviewBy,
  isProviderReview
} from '../../util/transaction';
import { LINE_ITEM_NIGHT, LINE_ITEM_DAY, propTypes } from '../../util/types';
import {
  ensureListing,
  ensureTransaction,
  ensureUser,
  userDisplayNameAsString,
} from '../../util/data';
import { isMobileSafari } from '../../util/userAgent';
import { formatMoney } from '../../util/currency';
import {
  AvatarLarge,
  BookingPanel,
  NamedLink,
  ReviewModal,
  UserDisplayName,
} from '../../components';
import { SendMessageForm } from '../../forms';
import config from '../../config';

// These are internal components that make this file more readable.
import AddressLinkMaybe from './AddressLinkMaybe';
import BreakdownMaybe from './BreakdownMaybe';
import DetailCardHeadingsMaybe from './DetailCardHeadingsMaybe';
import DetailCardImage from './DetailCardImage';
import FeedSection from './FeedSection';
import SaleActionButtonsMaybe from './SaleActionButtonsMaybe';
import PanelHeading, {
  HEADING_ENQUIRED,
  HEADING_PAYMENT_PENDING,
  HEADING_PAYMENT_EXPIRED,
  HEADING_REQUESTED,
  HEADING_ACCEPTED,
  HEADING_DECLINED,
  HEADING_CANCELED,
  HEADING_DELIVERED,
  HEADING_CONFIRMED,
} from './PanelHeading';
import { sendMail } from '../../util/api';

import css from './TransactionPanel.css';
import TransactionAlert from './TransactionAlert';
import { Button } from 'react-scroll';
import axios from 'axios';
// Helper function to get display names for different roles
const displayNames = (currentUser, currentProvider, currentCustomer, intl) => {
  const authorDisplayName = <UserDisplayName user={currentProvider} intl={intl} />;
  const customerDisplayName = <UserDisplayName user={currentCustomer} intl={intl} />;

  let otherUserDisplayName = '';
  let otherUserDisplayNameString = '';
  const currentUserIsCustomer =
    currentUser.id && currentCustomer.id && currentUser.id.uuid === currentCustomer.id.uuid;
  const currentUserIsProvider =
    currentUser.id && currentProvider.id && currentUser.id.uuid === currentProvider.id.uuid;

  if (currentUserIsCustomer) {
    otherUserDisplayName = authorDisplayName;
    otherUserDisplayNameString = userDisplayNameAsString(currentProvider, '');
  } else if (currentUserIsProvider) {
    otherUserDisplayName = customerDisplayName;
    otherUserDisplayNameString = userDisplayNameAsString(currentCustomer, '');
  }

  return {
    authorDisplayName,
    customerDisplayName,
    otherUserDisplayName,
    otherUserDisplayNameString,
  };
};

export class TransactionPanelComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sendMessageFormFocused: false,
      isReviewModalOpen: false,
      reviewSubmitted: false,

    };
    this.isMobSaf = false;
    this.sendMessageFormName = 'TransactionPanel.SendMessageForm';

    this.onOpenReviewModal = this.onOpenReviewModal.bind(this);
    this.onSubmitReview = this.onSubmitReview.bind(this);
    this.onSendMessageFormFocus = this.onSendMessageFormFocus.bind(this);
    this.onSendMessageFormBlur = this.onSendMessageFormBlur.bind(this);
    this.onMessageSubmit = this.onMessageSubmit.bind(this);
    this.scrollToMessage = this.scrollToMessage.bind(this);


  }



  componentDidMount() {
    this.isMobSaf = isMobileSafari();
    // this.lastLocation.current.value = "/inbox/orders"
  }

  onOpenReviewModal() {
    this.setState({ isReviewModalOpen: true });
  }

  onSubmitReview(values) {
    const { onSendReview, transaction, transactionRole } = this.props;
    const currentTransaction = ensureTransaction(transaction);
    const { reviewRating, reviewContent } = values;
    const rating = Number.parseInt(reviewRating, 10);
    onSendReview(transactionRole, currentTransaction, rating, reviewContent)
      .then(r => this.setState({ isReviewModalOpen: false, reviewSubmitted: true }))
      .catch(e => {
        // Do nothing.
      });
  }

  onSendMessageFormFocus() {
    this.setState({ sendMessageFormFocused: true });
    if (this.isMobSaf) {
      // Scroll to bottom
      if (window !== undefined)
        window.scroll({ top: document.body.scrollHeight, left: 0, behavior: 'smooth' });
    }
  }

  onSendMessageFormBlur() {
    this.setState({ sendMessageFormFocused: false });
  }

  onMessageSubmit(values, form) {
    const message = values.message ? values.message.trim() : null;
    const { transaction, onSendMessage } = this.props;
    const ensuredTransaction = ensureTransaction(transaction);

    if (!message) {
      return;
    }
    onSendMessage(ensuredTransaction.id, message)
      .then(messageId => {
        form.reset();
        this.scrollToMessage(messageId);
        window.location.reload(false);
      })
      .catch(e => {
        // Ignore, Redux handles the error
      });
  }

  scrollToMessage(messageId) {
    const selector = `#msg-${messageId.uuid}`;
    const el = document.querySelector(selector);
    if (el) {
      el.scrollIntoView({
        block: 'start',
        behavior: 'smooth',
      });
    }
  }
   buttonClicked = false

  render() {
    const {
      rootClassName,
      className,
      currentUser,
      transaction,
      totalMessagePages,
      oldestMessagePageFetched,
      messages,
      initialMessageFailed,
      savePaymentMethodFailed,
      fetchMessagesInProgress,
      fetchMessagesError,
      sendMessageInProgress,
      sendMessageError,
      sendReviewInProgress,
      sendReviewError,
      onManageDisableScrolling,
      onShowMoreMessages,
      transactionRole,
      intl,
      onAcceptSale,
      onDeclineSale,
      acceptInProgress,
      declineInProgress,
      acceptSaleError,
      declineSaleError,
      onSubmitBookingRequest,
      timeSlots,
      fetchTimeSlotsError,
      nextTransitions,
      onFetchTransactionLineItems,
      lineItems,
      fetchLineItemsInProgress,
      fetchLineItemsError,
      onRequestPayment,
      onBookingAfterEnq,
      onConfirmBooking,
    } = this.props;

    const currentTransaction = ensureTransaction(transaction);
    const currentListing = ensureListing(currentTransaction.listing);
    const currentProvider = ensureUser(currentTransaction.provider);
    const currentCustomer = ensureUser(currentTransaction.customer);
    const isCustomer = transactionRole === 'customer';
    const isProvider = transactionRole === 'provider';

    const listingLoaded = !!currentListing.id;
    const listingDeleted = listingLoaded && currentListing.attributes.deleted;
    const iscustomerLoaded = !!currentCustomer.id;
    const isCustomerBanned = iscustomerLoaded && currentCustomer.attributes.banned;
    const isCustomerDeleted = iscustomerLoaded && currentCustomer.attributes.deleted;
    const isProviderLoaded = !!currentProvider.id;
    const isProviderBanned = isProviderLoaded && currentProvider.attributes.banned;
    const isProviderDeleted = isProviderLoaded && currentProvider.attributes.deleted;


    const stateDataFn = tx => {
      if (txIsEnquired(tx)) {
        /*const transitions = Array.isArray(nextTransitions)
          ? nextTransitions.map(transition => {
              return transition.attributes.name;
            })
          : [];
        const hasCorrectNextTransition =
          transitions.length > 0 && transitions.includes(TRANSITION_REQUEST_PAYMENT_AFTER_ENQUIRY);*/
        return {
          headingState: HEADING_ENQUIRED,
          //showBookingPanel: isCustomer && !isProviderBanned,
          showDetailCardHeadings: isCustomer,
          showConfirmationButton: isCustomer,

        };
      } else if (txIsPaymentPending(tx)) {
        return {
          headingState: HEADING_PAYMENT_PENDING,
          showDetailCardHeadings: isCustomer,
        };
      } else if (txIsPaymentExpired(tx)) {
        return {
          headingState: HEADING_PAYMENT_EXPIRED,
          showDetailCardHeadings: isCustomer,
        };
      } else if (txIsBookingPending(tx)) {
        return {

          headingState: HEADING_REQUESTED,
          showDetailCardHeadings: isCustomer,
          showSaleButtons: isProvider && !isCustomerBanned,
        };
      } else if (txIsAccepted(tx)) {
        return {
          headingState: HEADING_ACCEPTED,
          showDetailCardHeadings: isCustomer,
          showAddress: isCustomer,
          showAcceptButton: isCustomer,
        };
      } else if (txIsDeclined(tx)) {
        return {
          headingState: HEADING_DECLINED,
          showDetailCardHeadings: isCustomer,
        };
      } else if (txIsCanceled(tx)) {
        return {
          headingState: HEADING_CANCELED,
          showDetailCardHeadings: isCustomer,
        };
      } else if (txIsConfirmed(tx)) {
        console.log('is here')
        return {
          headingState: HEADING_CONFIRMED,
          showDetailCardHeadings: isCustomer,
          showAddress: isCustomer,
        };
      } else if (txHasBeenDelivered(tx)) {
        return {
          headingState: HEADING_DELIVERED,
          showDetailCardHeadings: isCustomer,
          showAddress: isCustomer,
        };
      } else {
        return { headingState: 'unknown' };
      }
    };
    const stateData = stateDataFn(currentTransaction);


    const deletedListingTitle = intl.formatMessage({
      id: 'TransactionPanel.deletedListingTitle',
    });

    const {
      authorDisplayName,
      customerDisplayName,
      otherUserDisplayName,
      otherUserDisplayNameString,
    } = displayNames(currentUser, currentProvider, currentCustomer, intl);

    const { publicData, geolocation } = currentListing.attributes;
    const location = publicData && publicData.location ? publicData.location : {};
    const listingTitle = currentListing.attributes.deleted
      ? deletedListingTitle
      : currentListing.attributes.title;

    const unitType = config.bookingUnitType;
    const isNightly = unitType === LINE_ITEM_NIGHT;
    const isDaily = unitType === LINE_ITEM_DAY;

    const unitTranslationKey = isNightly
      ? 'TransactionPanel.perNight'
      : isDaily
      ? 'TransactionPanel.perDay'
      : 'TransactionPanel.perUnit';

    //Checking if custom Currency is set to Euro
    const currencyCheck = (customCurrency, shareTribePrice) => {
      if(customCurrency!==undefined){
        if ((customCurrency).includes('Euro')){
          return (shareTribePrice.substr(1)+ "€ " + bookingSubTitleText);
        }else{
          return shareTribePrice + bookingSubTitleText;
        }
      }else{
        return shareTribePrice + bookingSubTitleText;
      }
    }

    const price = currentListing.attributes.price;
    const bookingSubTitle = price
      ? `${formatMoney(intl, price)} `
      : '';
    const bookingSubTitleText = price
      ? ` ${intl.formatMessage({ id: unitTranslationKey })}`
      : '';
    //Checking if custom Currency is set to Euro
    const bookingSubTitleCurrencyAdjusted = currencyCheck(currentListing.attributes.publicData.customCurrency, bookingSubTitle);

    const sendWhatsappNotification = async (currentTransaction,bookingResponse) => {
     const twilioSid = config.twilio.twilioSID;
     const twilioAuthToken= config.twilio.twilioAuthToken;
     const senderPhone = config.twilio.senderPhone;
     let from = 'whatsapp:'+senderPhone;
     let to = `whatsapp:${currentTransaction.attributes.protectedData.phoneNumber}`;
     let twilioUrl = `https://api.twilio.com/2010-04-01/Accounts/${twilioSid}/Messages.json`;
     let sendNotifications = currentTransaction.customer.attributes.profile.publicData?.notifications ?? true;
     let isGerman = currentTransaction.attributes?.protectedData?.phoneNumber.toString().slice(0,3) !== '+49' ? false :true ;
     let customerName = currentTransaction.customer.attributes.profile.displayName;
     let message = '';
     let placeName = currentTransaction.listing.attributes.title;
    if(sendNotifications){
      if(!bookingResponse && isGerman){
         message = `Hallo ${customerName}, \ndeine Buchungsanfrage nach ${placeName} auf socialbnb wurde leider abgelehnt! \nBitte schau in deine Inbox. Falls du noch Fragen hast, melde dich bei uns!`
      }
      if(!bookingResponse && !isGerman){
         message = `Hello ${customerName}, \nyour booking request for ${placeName} on socialbnb has unfortunately been declined! \nPlease check your inbox. If you have any questions, please get in touch with us!`;
     }
      if(bookingResponse && isGerman){
         message = `Hallo ${customerName}, \ndeine Buchungsanfrage nach ${placeName} auf socialbnb wurde bestätigt! \nDu kannst dich jetzt mit deinem Gastgeber in Kontakt setzen.\nBitte schau in deine Inbox.`;
      }
      if(bookingResponse && !isGerman){
         message = `Hello ${customerName}, \nyour booking request for ${placeName} on socialbnb has been confirmed! \nYou can now get in touch with your host.\nPlease check your inbox.`;
      }

      await axios.post(twilioUrl, new URLSearchParams({
           Body : message,
           From : from,
           To : to,
        }), {
        auth: {
            username: twilioSid,
            password: twilioAuthToken
            }
         })
         .then(
             response => {
            console.log(response.data.sid);
          },
         error => {
         console.log(error);
          }
          );
      }
    }


    const firstImage =
      currentListing.images && currentListing.images.length > 0 ? currentListing.images[0] : null;

    const ReviewButton= (
      <div className={css.actionButtonWrapper} style={{padding:'0 3rem'}}>
      <button className={css.primaryButtonRoot} onClick={()=>this.onOpenReviewModal()}>

                <FormattedMessage id="TransactionPanel.reviewButton" />
      </button>
      </div>
    )
    const saleButtons = (
      <SaleActionButtonsMaybe
        showButtons={stateData.showSaleButtons}
        showAcceptButton={stateData.showAcceptButton}
        acceptInProgress={acceptInProgress}
        declineInProgress={declineInProgress}
        acceptSaleError={acceptSaleError}
        declineSaleError={declineSaleError}
        onAcceptSale={() => {onAcceptSale(currentTransaction.id);sendWhatsappNotification(currentTransaction,true);}}
        onDeclineSale={() =>{ onDeclineSale(currentTransaction.id); sendWhatsappNotification(currentTransaction,false);}}
        onRequestPayment={() => onRequestPayment(currentTransaction)}
        onConfirmBooking={() => {onConfirmBooking(currentTransaction)
                                  this.buttonClicked=true}}
        transaction={currentTransaction}

      />
    );

    const confirmationButton = (
      <SaleActionButtonsMaybe
        showConfirmationButton={stateData.showConfirmationButton}
        showButtons={stateData.showSaleButtons}
        showAcceptButton={stateData.showAcceptButton}
        acceptInProgress={acceptInProgress}
        declineInProgress={declineInProgress}
        acceptSaleError={acceptSaleError}
        declineSaleError={declineSaleError}
        onAcceptSale={() => onAcceptSale(currentTransaction.id)}
        onDeclineSale={() => onDeclineSale(currentTransaction.id)}
        onRequestPayment={() => onRequestPayment(transaction)}
        onConfirmBooking={() => {onConfirmBooking(transaction)
                                this.buttonClicked=true}}
        transaction={currentTransaction}
        showModalHandler={this.showModalHandler}
        hideModalHandler={this.hideModalHandler}

      />
    );

    const showSendMessageForm =
      !isCustomerBanned && !isCustomerDeleted && !isProviderBanned && !isProviderDeleted;

    const sendMessagePlaceholder = intl.formatMessage(
      { id: 'TransactionPanel.sendMessagePlaceholder' },
      { name: otherUserDisplayNameString.split(' ')[0] }
    );

    const sendingMessageNotAllowed = intl.formatMessage({
      id: 'TransactionPanel.sendingMessageNotAllowed',
    });

    const paymentMethodsPageLink = (
      <NamedLink name="PaymentMethodsPage">
        <FormattedMessage id="TransactionPanel.paymentMethodsPageLink" />
      </NamedLink>
    );

    const classes = classNames(rootClassName || css.root, className);

    const projectTitle = listingTitle.split(' • ')[0];

    const projectRoomtypeRaw = listingTitle.split(' • ')[1];

    const ProjectRoomtype =
      projectRoomtypeRaw === 'singlebedroom'
        ? intl.formatMessage({
            id: 'roomtypes.singlebedroom',
          })
        : projectRoomtypeRaw === 'twobedroom'
        ? intl.formatMessage({
            id: 'roomtypes.twobedroom',
          })
        : projectRoomtypeRaw === 'doublebedroom'
        ? intl.formatMessage({
            id: 'roomtypes.doublebedroom',
          })
        : projectRoomtypeRaw === 'shared_bedroom'
        ? intl.formatMessage({
            id: 'roomtypes.shared_bedroom',
          })
        : projectRoomtypeRaw === 'entire_accomodation'
        ? intl.formatMessage({
            id: 'roomtypes.entire_accomodation',
          })
        : projectRoomtypeRaw === 'camping'
        ? intl.formatMessage({
            id: 'roomtypes.camping',
          })
        : null;

    const listingsTitleNew = projectTitle  + ' - ' + ProjectRoomtype;

    ////////////////////////////////////////////////
    const labelArrayGuest=[
      <FormattedMessage id="TransactionPanel.progressBarGuest"/>,
      <FormattedMessage id="TransactionPanel.progressBarGuest2"/>,
      <FormattedMessage id="TransactionPanel.progressBarGuest3"/>,
      <FormattedMessage id="TransactionPanel.progressBarGuest4"/>,
      <FormattedMessage id="TransactionPanel.progressBarGuest5"/>
    ]

    const labelArrayHost=[
      <FormattedMessage id="TransactionPanel.progressBarHost"/>,
      <FormattedMessage id="TransactionPanel.progressBarHost2"/>,
      <FormattedMessage id="TransactionPanel.progressBarHost3"/>
    ]

    return (
      <div className={classes}>
        <TransactionAlert  showConfirmationButton = {stateData.showConfirmationButton} conformationChecker={()=> this.buttonClicked}/>

        <div className={css.headerContainer}>
            {/*PROGRSS BAR*/}
            {isProvider ?
            ( (() => {
              switch (stateData.headingState) {
              case HEADING_REQUESTED:
              return <div>
              <StepNavigation labelArray={labelArrayHost} status={5}></StepNavigation>
              <ProgressBar bgcolor="#1c7881" progress='33' height={5} />
              </div>
              case HEADING_ACCEPTED:
              return <div>
              <StepNavigation labelArray={labelArrayHost} status={6}></StepNavigation>
              <ProgressBar bgcolor="#1c7881" progress='66' height={5} />
            </div>
              case HEADING_CONFIRMED:
              return <div>
              <StepNavigation labelArray={labelArrayHost}status={7}></StepNavigation>
              <ProgressBar bgcolor="#1c7881" progress='100' height={5} />
              </div>
              default: console.log("what is this state?,",stateData.headingState);
              return null
              }
            })() )

            :
            ( (() => {
              switch (stateData.headingState) {
              case HEADING_ENQUIRED:
              console.log('state: 1');
              return <div>
              <StepNavigation labelArray={labelArrayGuest} status={1}></StepNavigation>
              <ProgressBar bgcolor="#1c7881" progress='34' height={5} />
              </div>
              case HEADING_REQUESTED:
                console.log('state: 2');
              return <div>
              <StepNavigation labelArray={labelArrayGuest} status={2}></StepNavigation>
              <ProgressBar bgcolor="#1c7881" progress='55' height={5} />
            </div>
              case HEADING_ACCEPTED:
                console.log('state: 3');
              return <div>
              <StepNavigation labelArray={labelArrayGuest} status={3}></StepNavigation>
              <ProgressBar bgcolor="#1c7881" progress='82' height={5} />
            </div>
              case HEADING_CONFIRMED:
                console.log('state: 4');
              return <div>
              <StepNavigation labelArray={labelArrayGuest} status={4}></StepNavigation>
              <ProgressBar bgcolor="#1c7881" progress='100' height={5} />
              </div>
              default:
              return null
              }
            })() )
            }
            {/*PROGRSS BAR END*/}


            <PanelHeading
              panelHeadingState={stateData.headingState}
              transactionRole={transactionRole}
              providerName={authorDisplayName}
              customerName={customerDisplayName}
              isCustomerBanned={isCustomerBanned}
              listingId={currentListing.id && currentListing.id.uuid}
              listingTitle={listingsTitleNew}
              listingDeleted={listingDeleted}
            />
          </div>


        <div className={css.container}>
          <div className={css.txInfo}>
            <DetailCardImage
              rootClassName={css.imageWrapperMobile}
              avatarWrapperClassName={css.avatarWrapperMobile}
              listingTitle={listingsTitleNew}
              image={firstImage}
              provider={currentProvider}
              isCustomer={isCustomer}
            />
            {isProvider ? (
              <div className={css.avatarWrapperProviderDesktop}>
                <AvatarLarge user={currentCustomer} className={css.avatarDesktop} />
              </div>
            ) : null}





            <div className={css.bookingDetailsMobile}>
              {/* <AddressLinkMaybe
                rootClassName={css.addressMobile}
                location={location}
                geolocation={geolocation}
                showAddress={stateData.showAddress}
              /> */}
              <BreakdownMaybe
                listing={currentListing}
                listingTitle={listingTitle}
                projectRoomtypeRaw={projectRoomtypeRaw}
                transaction={currentTransaction}
                transactionRole={transactionRole}
                showConfirmationButton={stateData.showConfirmationButton}
              />
            </div>

            {savePaymentMethodFailed ? (
              <p className={css.genericError}>
                <FormattedMessage
                  id="TransactionPanel.savePaymentMethodFailed"
                  values={{ paymentMethodsPageLink }}
                />
              </p>
            ) : null}

            <div className={css.chatWindow}>
              <FeedSection
                customerName={customerDisplayName}
                providerName={authorDisplayName}
                isCustomer={isCustomer}
                rootClassName={css.feedContainer}
                currentTransaction={currentTransaction}
                currentUser={currentUser}
                fetchMessagesError={fetchMessagesError}
                fetchMessagesInProgress={fetchMessagesInProgress}
                initialMessageFailed={initialMessageFailed}
                messages={messages}
                oldestMessagePageFetched={oldestMessagePageFetched}
                onOpenReviewModal={this.onOpenReviewModal}
                onShowMoreMessages={() => onShowMoreMessages(currentTransaction.id)}
                totalMessagePages={totalMessagePages}
              />
              {showSendMessageForm ? (
                <SendMessageForm
                  formId={this.sendMessageFormName}
                  rootClassName={css.sendMessageForm}
                  messagePlaceholder={sendMessagePlaceholder}
                  inProgress={sendMessageInProgress}
                  sendMessageError={sendMessageError}
                  onFocus={this.onSendMessageFormFocus}
                  onBlur={this.onSendMessageFormBlur}
                  onSubmit={this.onMessageSubmit}
                  className={css.transactionSubmit}
                />
              ) : (
                <div className={css.sendingMessageNotAllowed}>{sendingMessageNotAllowed}</div>
              )}
            </div>


            {stateData.showSaleButtons || stateData.showAcceptButton ? (
              <div className={css.mobileActionButtons}>{saleButtons}</div>
            ) : null}
            {stateData.showConfirmationButton ? (
                <div className={css.mobileActionButtons}>{confirmationButton}</div>
              ) : null}
          </div>

          <div className={css.asideDesktop}>
            <div className={css.detailCard}>
              <DetailCardImage
                avatarWrapperClassName={css.avatarWrapperDesktop}
                listingTitle={listingsTitleNew}
                image={firstImage}
                provider={currentProvider}
                isCustomer={isCustomer}
              />
              <DetailCardHeadingsMaybe
                showDetailCardHeadings={stateData.showDetailCardHeadings}
                listingTitle={listingsTitleNew}
                subTitle={bookingSubTitleCurrencyAdjusted}
                location={location}
                geolocation={geolocation}
                showAddress={stateData.showAddress}
              />
              {stateData.showBookingPanel ? (
                <BookingPanel
                  projectRoomtypeRaw={projectRoomtypeRaw}
                  ProjectRoomtype={ProjectRoomtype}
                  bedamount={publicData.bedamount}
                  className={css.bookingPanel}
                  titleClassName={css.bookingTitle}
                  isOwnListing={false}
                  listing={currentListing}
                  title={listingsTitleNew}
                  subTitle={bookingSubTitleCurrencyAdjusted}
                  authorDisplayName={authorDisplayName}
                  onSubmit={onBookingAfterEnq}
                  onManageDisableScrolling={onManageDisableScrolling}
                  timeSlots={timeSlots}
                  fetchTimeSlotsError={fetchTimeSlotsError}
                  onFetchTransactionLineItems={onFetchTransactionLineItems}
                  lineItems={lineItems}
                  fetchLineItemsInProgress={fetchLineItemsInProgress}
                  fetchLineItemsError={fetchLineItemsError}
                  isCustomer={isCustomer}
                  isProvider={isProvider}
                  isAuthenticated={isCustomer}
                  currentUser={currentUser}
                />
              ) : null}
              <BreakdownMaybe
                listing={currentListing}
                className={css.breakdownContainer}
                transaction={currentTransaction}
                transactionRole={transactionRole}
                projectRoomtypeRaw={projectRoomtypeRaw}
              />

              {stateData.showSaleButtons || stateData.showAcceptButton ? (
                <div className={css.desktopActionButtons}>{saleButtons}</div>
              ) : null}
              {stateData.showConfirmationButton ? (
                <div className={css.desktopActionButtons}>{confirmationButton}</div>
              ) : null}


              {!isProvider && txIsBookingPending((transaction)) ? (
                <div className={css.buttonMessage}>
                <FormattedMessage id="TransactionPanel.confirmBooking" />
                </div>
              ) : null
              }

              {isProvider && txIsAccepted((transaction)) ? (
                <div className={css.buttonMessage}>
                <FormattedMessage id="TransactionPanel.saleAccepted" values={{customerDisplayName}}/>
                </div>
              ) : null
              }

              {isProvider && txIsAccepted((transaction)) ? (
                <div className={css.feeInfo}>
                  <FormattedMessage id="BookingBreakdown.commissionFeeNote" />
                </div>
              ) : null}
              {isCustomer && txHasBeenDelivered(transaction) && !txIsInFirstReviewBy(transaction, isCustomer)?<div>{ReviewButton}</div>:<></>}
              {isProvider && txHasBeenDelivered(transaction) && !txIsInFirstReviewBy(transaction, isProvider)?<div>{ReviewButton}</div>:<></>}
            <div className={css.contactPanel}><a href="mailto:info@socialbnb.de" title="info@socialbnb.de" ><FormattedMessage id="Imprint.emailinfo"/></a></div></div>

          </div>
        </div>
        <ReviewModal
          id="ReviewOrderModal"
          isOpen={this.state.isReviewModalOpen}
          onCloseModal={() => this.setState({ isReviewModalOpen: false })}
          onManageDisableScrolling={onManageDisableScrolling}
          onSubmitReview={this.onSubmitReview}
          revieweeName={otherUserDisplayName}
          reviewSent={this.state.reviewSubmitted}
          sendReviewInProgress={sendReviewInProgress}
          sendReviewError={sendReviewError}
        />
      </div>
    );
  }
}

TransactionPanelComponent.defaultProps = {
  rootClassName: null,
  className: null,
  currentUser: null,
  acceptSaleError: null,
  declineSaleError: null,
  fetchMessagesError: null,
  initialMessageFailed: false,
  savePaymentMethodFailed: false,
  sendMessageError: null,
  sendReviewError: null,
  timeSlots: null,
  fetchTimeSlotsError: null,
  nextTransitions: null,
  lineItems: null,
  fetchLineItemsError: null,
};

TransactionPanelComponent.propTypes = {
  rootClassName: string,
  className: string,

  currentUser: propTypes.currentUser,
  transaction: propTypes.transaction.isRequired,
  totalMessagePages: number.isRequired,
  oldestMessagePageFetched: number.isRequired,
  messages: arrayOf(propTypes.message).isRequired,
  initialMessageFailed: bool,
  savePaymentMethodFailed: bool,
  fetchMessagesInProgress: bool.isRequired,
  fetchMessagesError: propTypes.error,
  sendMessageInProgress: bool.isRequired,
  sendMessageError: propTypes.error,
  sendReviewInProgress: bool.isRequired,
  sendReviewError: propTypes.error,
  onManageDisableScrolling: func.isRequired,
  onShowMoreMessages: func.isRequired,
  onSendMessage: func.isRequired,
  onSendReview: func.isRequired,
  onSubmitBookingRequest: func.isRequired,
  timeSlots: arrayOf(propTypes.timeSlot),
  fetchTimeSlotsError: propTypes.error,
  nextTransitions: array,

  // Sale related props
  onAcceptSale: func.isRequired,
  onDeclineSale: func.isRequired,
  acceptInProgress: bool.isRequired,
  declineInProgress: bool.isRequired,
  acceptSaleError: propTypes.error,
  declineSaleError: propTypes.error,

  // line items
  onFetchTransactionLineItems: func.isRequired,
  lineItems: array,
  fetchLineItemsInProgress: bool.isRequired,
  fetchLineItemsError: propTypes.error,

  // from injectIntl
  intl: intlShape,
};

const TransactionPanel = injectIntl(TransactionPanelComponent);

export default TransactionPanel;
